export default function (keys, callback) {
    const resolvers = {};
    const promises = keys.map(key => new Promise(resolve => resolvers[key] = resolve));
    Promise.all(promises).then(callback);

    return resolvers
}
